import React, { useContext, useEffect, useState } from 'react';
import { Autocomplete, Box, Button, Card, Chip, FormControl, FormControlLabel, FormLabel, Grid, IconButton, MenuItem, Modal, Radio, RadioGroup, Select, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { Add, ArrowBack } from '@mui/icons-material';
import { useForm ,Controller, FormProvider, set,useFormContext} from 'react-hook-form';
import { isMobile } from 'react-device-detect';

import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import { Helpers } from '../../../services/Helpers';
import dayjs from 'dayjs';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BannerDataContext } from './AddEditBanner';
import AddEditCategory from './bannerCategory/AddEditCategory';
import GenerateAppUrl from './GenerateAppUrl';
import useResponsive from '../../../hooks/useResponsive';

const platformOptions = ['Customer-App','SE-App','Customer-Web','SE-Web'];
const aspectRatioOptions = ['1:1','2:1','3:1','3:2','4:1','4:3','5:4','9:16','16:9','21:9'];

const BannerForm = () => {
    const {bannerData,combineDateAndTime,setLastChanged,fetchBannerCategories,bannerCategoryList} = useContext(BannerDataContext);
    const {control,watch,handleSubmit,setValue,formState:{isDirty,errors,dirtyFields },reset} = useFormContext({
        mode: 'onSubmit',
        defaultValues: bannerData,
    })
    const { isSm } = useResponsive();
    
    const type = watch('bannerType');
    const startDate = watch('startDate');
    const startTime = watch('startTime');
    const endDate = watch('expireDate');
    const endTime = watch('endTime');
    const aspectRatio = watch('aspectRatio');
    const urlType = watch('urlType');

    const [openGenerateAppUrl, setOpenGenerateAppUrl] = useState(false);

    useEffect(() => {
        if (urlType){
            if(urlType == 'appUrl'){
                if(bannerData.id && bannerData.appUrl){
                    setValue('appUrl',bannerData.appUrl);
                } else{             
                    setValue('linkUrl','');
                }
            }else if(urlType == 'linkUrl'){
                if(bannerData.id && bannerData.linkUrl){
                    setValue('linkUrl',bannerData.linkUrl);
                }else{                    
                    setValue('appUrl','');
                }
            }
        }
    }, [urlType]);
    

    const [openBannerSectionDialog, setOpenBannerSectionDialog] = useState(false);
    const onCloseDialog = () => {
        setOpenBannerSectionDialog(false);
        fetchBannerCategories();
    }
    
    const attachLink = (name)=>{
        return(
            <Box sx={{display:'flex',alignItems:'center',gap:1,}}>
                <Controller
                    control={control}
                    name={name}
                    rules={{
                        validate:value=>{
                            if(type === 'interactive' && !value){
                                return 'Enter Link'
                            }
                        }
                    }}
                    render={({field,fieldState:{error}})=>(
                        <TextField
                            {...field}
                            disabled={type != 'interactive' || !watch('urlType')}
                            placeholder='Enter url'
                            fullWidth
                            size='small'
                            error={!!error}
                            InputProps={{
                                style: {fontSize:'0.75rem'}
                            }}
                        />
                    )}
                />
                {urlType == 'appUrl' && <Tooltip title="Generate App Url">
                    <IconButton size='small' color='primary' sx={{}} onClick={()=>setOpenGenerateAppUrl(true)}><AddToPhotosIcon sx={{fontSize:'1rem',fontWeight:'bold'}}/></IconButton>
                </Tooltip>}
            </Box>
        )
    }
  return (
    <>
        <Grid item xs={12} md={8}>
            <Card sx={{p:2}}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Banner Title <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            name="title"
                            control={control}
                            rules={{
                                required:'Enter Title',
                            }}
                            render={({ field,fieldState:{error} }) => 
                                <TextField 
                                    {...field} 
                                    fullWidth 
                                    size='small'
                                    error={!!error}
                                    InputProps={{
                                        style: {fontSize:'0.75rem'}
                                    }}
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={1} sx={{display:{xs:'none',md:'block'}}}/>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Select Platform <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            name="platformName"
                            control={control}
                            rules={{
                                required:'Select Platform',
                            }}
                            render={({ field,fieldState:{error} }) => 
                                <Autocomplete
                                    {...field}
                                    size='small'
                                    sx={{
                                        '& .MuiAutocomplete-input': {
                                            fontSize: '0.75rem',
                                        },
                                        }}
                                    // multiple
                                    options={platformOptions}
                                    onChange={(event, newValue) => {
                                        field.onChange(newValue); // This is the key fix
                                    }}
                                    // defaultValue={[top100Films[13].title]}
                                    getOptionLabel={(option) => option}
                                    // renderTags={(value, getTagProps) =>
                                    // value.map((option, index) => (
                                    //     <Chip size='small' sx={{fontSize:'0.75rem'}} variant="outlined" label={option} {...getTagProps({ index })} />
                                    // ))
                                    
                                    // }
                                    renderOption={(props, option, { selected }) => (
                                        <MenuItem {...props}>
                                            <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                                                {option}
                                            </Typography>
                                        </MenuItem>
                                    )}
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size='small'
                                        error={!!error}
                                        // label="platform"
                                        // placeholder="Platform"
                                    />
                                    )}
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={12} sm={5.5} >
                        <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                            <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Banner Category <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                            {/* <IconButton size='small' color='succes' sx={{}}><Add sx={{fontSize:'1rem',fontWeight:'bold',color:'green'}}/></IconButton> */}
                            <Typography sx={{fontSize:'1rem',fontWeight:600,color:'green',cursor:'pointer'}} onClick={()=>setOpenBannerSectionDialog(true)}>+</Typography>
                        </Box>
                        <Controller
                            control={control}
                            name="bannerCategory"
                            rules={{
                                required:'select Banner category',
                            }}
                            render={({field,fieldState:{error}})=>(
                                <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                                    <Select
                                        {...field}
                                        error={!!error}
                                        sx={{
                                            fontSize:'0.75rem',
                                        }}
                                    >
                                        {
                                            bannerCategoryList && bannerCategoryList.length>0 && bannerCategoryList.map((item,index)=>(
                                                <MenuItem key={index} value={item.title} sx={{textTransform:'capitalize',fontSize:'0.75rem'}}>{item.title}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>
                            )}
                        />
                    </Grid>
                    <Grid item xs={1} sx={{display:{xs:'none',md:'block'}}}/>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Banner Position <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            control={control}
                            name="bannerPosition"
                            rules={{
                                required:'select Banner Position',
                            }}
                            render={({field,fieldState:{error}})=>(
                                <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                                    <Select
                                        {...field}
                                        error={!!error}
                                        sx={{
                                            fontSize:'0.75rem',
                                        }}
                                    >
                                        <MenuItem value={'Top'} sx={{textTransform:'capitalize',fontSize:'0.75rem'}}>Top</MenuItem>
                                        <MenuItem value={'Middle'} sx={{textTransform:'capitalize',fontSize:'0.75rem'}}>Middle</MenuItem>
                                        <MenuItem value={'Bottom'} sx={{textTransform:'capitalize',fontSize:'0.75rem'}}>Bottom</MenuItem>
                                    </Select>
                                </FormControl>
                            )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid item xs={12} sm={5.5}>
                            <Box sx={{display:'flex',alignItems:'center',gap:2}}>
                                <Typography sx={{fontSize:'0.85rem',fontWeight:600 }}>Is Slider  : </Typography>
                                <FormControl component="fieldset" >
                                    <Controller
                                    name="isSlider"
                                    control={control}
                                    rules={{ 
                                        // required:'select isSlider',
                                    }}
                                    render={({ field }) => (
                                    <RadioGroup {...field} row >
                                        <FormControlLabel 
                                            value={true}
                                            control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }}/>} 
                                            label="Yes" 
                                            sx={{
                                                '& .MuiFormControlLabel-label': {
                                                fontSize: '0.75rem'
                                                }
                                            }}
                                        />
                                        <FormControlLabel 
                                            value={false} 
                                            control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }}/>} 
                                            label="No" 
                                            sx={{
                                                '& .MuiFormControlLabel-label': {
                                                fontSize: '0.75rem'
                                                }
                                            }}
                                        />
                                    </RadioGroup>
                                    )}
                                />
                            </FormControl>
                            {errors?.isSlider && <Typography sx={{fontSize:'0.4rem',color:'#d32f2f'}}>choose one</Typography>}
                        </Box>
                        </Grid>
                    </Grid>
                    {/* 🖼 Image Dimensions Fields */}
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>
                            Aspect Ratio <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box>
                        </Typography>
                        <Controller
                            name="aspectRatio"
                            control={control}
                            rules={{ required: 'Enter Aspect Ratio (e.g., 16:9)' }}
                            render={({ field, fieldState: { error } }) => (
                                <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                                    <Select
                                        {...field}
                                        error={!!error}
                                        sx={{
                                            fontSize:'0.75rem',
                                        }}
                                    >
                                        {aspectRatioOptions.map((option, index) => (
                                            <MenuItem key={index} value={option} sx={{textTransform:'capitalize',fontSize:'0.75rem'}}>{option}</MenuItem>
                                        ))}  
                                    </Select>
                                </FormControl>
                            )}
                        />
                    </Grid>
                    
                    {/* <Grid item xs={12} sm={5.5}>
                        <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>
                            Image Height (px) <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box>
                        </Typography>
                        
                    </Grid> */}
                    <Grid item xs={1} sx={{display:{xs:'none',md:'block'}}}/>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{ fontSize: '0.85rem', fontWeight: 600,color: !aspectRatio && 'lightGray' }}>
                            Banner Dimension (px) <Box component={'span'} sx={{ color: !aspectRatio?'lightGray':'#d32f2f' }}>*</Box>
                        </Typography>
                        <Box sx={{display:'flex',alignItems:'center',gap:1}}>
                            <Controller
                                name="width"
                                control={control}
                                rules={{ required: 'Enter Image Width',
                                    validate: value => {
                                        // // Allow empty value
                                        // if (value === '' || value === null || value === undefined) {
                                        //     return true;
                                        // }
                                        // If there is a value, ensure it's a positive integer
                                        if (Number(value) <= 0) {
                                            return 'Please enter a positive number';
                                        }
                                        return true;
                                    }
                                    }}
                                render={({ field, fieldState: { error } }) => (
                                    <TextField
                                        {...field}
                                        disabled={!aspectRatio}
                                        type="number"
                                        fullWidth
                                        size="small"
                                        error={!!error}
                                        onChange={(e) => {
                                            const inputValue = e.target.value;
                                            // Allow empty value
                                            if (inputValue === '') {
                                                field.onChange('');
                                                return;
                                            }

                                            let value = formatValue(parseInt(e.target.value));
                                            if (value < 0 || isNaN(value)) {
                                                value = 0;
                                            }
                                            setLastChanged('width');
                                            field.onChange(value);
                                        }}
                                        InputProps={{ style: { fontSize: '0.75rem' } }}
                                    />
                                )}
                            />
                            <Typography sx={{fontSize:'0.75rem'}}>X</Typography>
                            <Controller
                                name="height"
                                control={control}
                                rules={{ required: 'Enter Image Height',
                                    validate: value => {
                                        // // Allow empty value
                                        // if (value === '' || value === null || value === undefined) {
                                        //     return true;
                                        // }
                                        // If there is a value, ensure it's a positive integer
                                        if (Number(value) <= 0) {
                                            return 'Please enter a positive number';
                                        }
                                        return true;
                                    }
                                    }}
                                render={({ field, fieldState: { error } }) => (
                                    <TextField
                                        {...field}
                                        disabled={!aspectRatio}
                                        type="number"
                                        fullWidth
                                        size="small"
                                        error={!!error}
                                        onChange={(e) => {
                                            const inputValue = e.target.value;
                                            // Allow empty value
                                            if (inputValue === '') {
                                                field.onChange('');
                                                return;
                                            }

                                            let value = formatValue(parseInt(e.target.value));
                                            if (value < 0 || isNaN(value)) {
                                                value = 0;
                                            }
                                            setLastChanged('height');
                                            field.onChange(value);
                                            }}
                                        InputProps={{ style: { fontSize: '0.75rem' } }}
                                    />
                                )}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Banner Type <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            control={control}
                            name="bannerType"
                            rules={{
                                required:'select Banner Type',
                            }}
                            render={({field,fieldState:{error}})=>(
                                <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                                    <Select
                                        {...field}
                                        error={!!error}
                                        sx={{
                                            fontSize:'0.75rem',
                                        }}
                                    >
                                        <MenuItem value='static' sx={{textTransform:'capitalize',fontSize:'0.75rem'}}>Static</MenuItem>
                                        <MenuItem value='interactive' sx={{textTransform:'capitalize',fontSize:'0.75rem'}}>Interactive</MenuItem>
                                    </Select>
                                </FormControl>
                            )}
                        />
                    </Grid>
                    <Grid item xs={1} sx={{display:{xs:'none',md:'block'}}}/>
                    <Grid item xs={12} sm={5.5}>
                        <Box sx={{display:'flex',alignItems:'center',gap:2}}>
                            <Typography sx={{fontSize:'0.85rem',fontWeight:600 ,color:type != 'interactive'&& 'lightGray'}}>Url Type <Box component={'span'} sx={{color:type != 'interactive'?'lightGray':'#d32f2f'}}>*</Box> : </Typography>
                            <FormControl component="fieldset" >
                                <Controller
                                    name="urlType"
                                    control={control}
                                    rules={{ 
                                        validate:value=>{
                                            if(type === 'interactive' && !value){
                                                return 'Choose one'
                                            }
                                        }
                                        }}
                                    render={({ field }) => (
                                    <RadioGroup {...field} row >
                                        <FormControlLabel 
                                            disabled={type!='interactive'}
                                            value="appUrl" 
                                            control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }}/>} 
                                            label="App Url" 
                                            sx={{
                                                '& .MuiFormControlLabel-label': {
                                                fontSize: '0.75rem'
                                                }
                                            }}
                                        />
                                        <FormControlLabel 
                                            disabled={type!='interactive'}
                                            value="linkUrl" 
                                            control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }}/>} 
                                            label="Web Url" 
                                            sx={{
                                                '& .MuiFormControlLabel-label': {
                                                fontSize: '0.75rem'
                                                }
                                            }}
                                        />
                                    </RadioGroup>
                                    )}
                                />
                            </FormControl>
                            {errors?.urlType && <Typography sx={{fontSize:'0.4rem',color:'#d32f2f'}}>choose one</Typography>}
                        </Box>
                        {watch('urlType')== 'appUrl' &&
                            attachLink('appUrl')
                        }
                        {watch('urlType')== 'linkUrl' &&
                            attachLink('linkUrl')
                        }
                    </Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Start Date <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            control={control}
                            name="startDate"
                            // defaultValue={dayjs().format('YYYY-MM-DD')}
                            rules={{
                                required: 'Start Date is required',
                                validate: (value) => {
                                    if (!value) return "This field is required";
                                    const date = dayjs(value);
                                    const today = dayjs().startOf('day');
                                    
                                    if (!date.isValid()) return "Invalid date";
                                    if (date.isBefore(today)) return "Start date must be in the future";
                                    
                                    return true;
                                }
                            }}
                            render={({ field: { onChange, value, ...restField }, fieldState: { error } }) => (
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DesktopDatePicker
                                        {...restField}
                                        sx={{
                                            width: '100%',
                                            '& .MuiInputBase-root': {
                                                fontSize: '0.75rem'
                                            }
                                        }}
                                        value={value ? dayjs(value) : null}
                                        onChange={(newValue) => {
                                            onChange(newValue ? newValue.format("YYYY-MM-DD") : null);
                                        }}
                                        format="DD-MM-YYYY"
                                        minDate={dayjs()}
                                        slotProps={{
                                            textField: {
                                                error: !!error,
                                                // helperText: error?.message,
                                                fullWidth: true,
                                                size: 'small',
                                                inputProps: {
                                                    style: { fontSize: '.75rem' }
                                                }
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            )}
                        />
                    </Grid>
                    <Grid item xs={1} sx={{display:{xs:'none',md:'block'}}}/>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Start Time <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            control={control}
                            name="startTime"
                            rules={{
                                required: 'Enter Start Time',
                                validate: (value) => {
                                    const startDateTime = combineDateAndTime(startDate, value);
                                    if (!startDateTime) return true; // Let required validation handle this
                                    if (startDateTime < new Date()) {
                                        return 'Start time must be in the future';
                                    }
                                    return true;
                                }
                            }}
                            render={({field,fieldState:{error}})=>(
                                <TextField
                                    {...field}
                                    type='time'
                                    fullWidth
                                    size='small'
                                    error={!!error}
                                    InputProps={{
                                        style: {fontSize:'0.75rem'}
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>End Date <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            control={control}
                            name="expireDate"
                            // defaultValue={dayjs().add(1, 'day').format('YYYY-MM-DD')}
                            rules={{
                                required: 'End Date is required',
                                validate: (value) => {
                                    if (!value) return "This field is required";
                                    const date = dayjs(value);
                                    const startDateValue = watch('startDate');
                                    const startDate = dayjs(startDateValue);
                                    
                                    if (!date.isValid()) return "Invalid date";
                                    if (!startDateValue) return true; // Let the required validation handle this
                                    if (date.isBefore(startDate)) return "End date must be after start date";
                                    
                                    return true;
                                }
                            }}
                            render={({ field: { onChange, value, ...restField }, fieldState: { error } }) => (
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DesktopDatePicker
                                        {...restField}
                                        sx={{
                                            width: '100%',
                                            '& .MuiInputBase-root': {
                                                fontSize: '0.75rem'
                                            }
                                        }}
                                        value={value ? dayjs(value) : null}
                                        onChange={(newValue) => {
                                            onChange(newValue ? newValue.format("YYYY-MM-DD") : null);
                                        }}
                                        format="DD-MM-YYYY"
                                        minDate={watch('startDate') ? dayjs(watch('startDate')) : dayjs()}
                                        slotProps={{
                                            textField: {
                                                error: !!error,
                                                // helperText: error?.message,
                                                fullWidth: true,
                                                size: 'small',
                                                inputProps: {
                                                    style: { fontSize: '.75rem' }
                                                }
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            )}
                        />
                    </Grid>
                    <Grid item xs={1} sx={{display:{xs:'none',md:'block'}}}/>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>End Time <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            control={control}
                            name="endTime"
                            rules={{
                                required: 'Enter End Time',
                                validate: (value) => {
                                    const endDateTime = combineDateAndTime(endDate, value);
                                    const startDateTime = combineDateAndTime(startDate, startTime);
                                    
                                    if (!endDateTime || !startDateTime) return true; // Let required validation handle this
                                    
                                    if (endDateTime < new Date()) {
                                        return 'End time must be in the future';
                                    }
                                    
                                    // Check if dates are the same and times are equal
                                    if (startDate === endDate && value === startTime) {
                                        return 'End time must be after start time when dates are the same';
                                    }
                                    
                                    if (endDateTime <= startDateTime) {
                                        return 'End time must be after start time';
                                    }
                                    
                                    return true;
                                }
                            }}
                            render={({field,fieldState:{error}})=>(
                                <TextField
                                    {...field}
                                    type='time'
                                    fullWidth
                                    size='small'
                                    error={!!error}
                                    InputProps={{
                                        style: {fontSize:'0.75rem'}
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Latitude</Typography>
                        <Controller
                            control={control}
                            name="latitude"
                            rules={{
                                validate: value => {
                                    // Allow empty values
                                    if (value === '' || value === null || value === undefined) {
                                        return true;
                                    }
                                    const lat = Number(value);
                                    if (isNaN(lat)) {
                                        return 'Must be a valid number';
                                    }
                                    if (lat < -90 || lat > 90) {
                                        return 'Latitude must be between -90 and 90';
                                    }
                                    if (value.toString().includes('.') && 
                                        value.toString().split('.')[1].length > 8) {
                                        return 'Maximum 8 decimal places allowed';
                                    }
                                    return true;
                                }
                            }}
                            render={({field,fieldState:{error}})=>(
                                <TextField
                                    {...field}
                                    fullWidth
                                    size='small'
                                    error={!!error}
                                    InputProps={{
                                        style: {fontSize:'0.75rem'},
                                        onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                        onKeyDown: (e) => {
                                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                e.preventDefault();
                                            }
                                        }
                                    }}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === '' || value === '-') {
                                            field.onChange(value);
                                            return;
                                        }
                                        
                                        const numValue = Number(value);
                                        if (!isNaN(numValue)) {
                                            field.onChange(value);
                                        }
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={1} sx={{display:{xs:'none',md:'block'}}}/>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Longitude</Typography>
                        <Controller
                            control={control}
                            name="longitude"
                            rules={{
                                validate: value => {
                                    // Allow empty values
                                    if (value === '' || value === null || value === undefined) {
                                        return true;
                                    }
                                    const lng = Number(value);
                                    if (isNaN(lng)) {
                                        return 'Must be a valid number';
                                    }
                                    if (lng < -180 || lng > 180) {
                                        return 'Longitude must be between -180 and 180';
                                    }
                                    if (value.toString().includes('.') && 
                                        value.toString().split('.')[1].length > 8) {
                                        return 'Maximum 8 decimal places allowed';
                                    }
                                    return true;
                                }
                            }}
                            render={({field,fieldState:{error}})=>(
                                <TextField
                                    {...field}
                                    fullWidth
                                    size='small'
                                    error={!!error}
                                    InputProps={{
                                        style: {fontSize:'0.75rem'},
                                        onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                        onKeyDown: (e) => {
                                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                e.preventDefault();
                                            }
                                        }
                                    }}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === '' || value === '-') {
                                            field.onChange(value);
                                            return;
                                        }
                                        
                                        const numValue = Number(value);
                                        if (!isNaN(numValue)) {
                                            field.onChange(value);
                                        }
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Coverage Area( in km)</Typography>
                        <Controller
                            control={control}
                            name="areaInKm"
                            rules={{
                                validate: value => {
                                    // Allow empty value
                                    if (value === '' || value === null || value === undefined) {
                                        return true;
                                    }
                                    // If there is a value, ensure it's a positive integer
                                    if (Number(value) <= 0) {
                                        return 'Please enter a positive number';
                                    }
                                    return true;
                                }
                            }}
                            render={({field,fieldState:{error}})=>(
                                <TextField
                                    {...field}
                                    fullWidth
                                    size='small'
                                    error={!!error}
                                    InputProps={{
                                        style: {fontSize:'0.75rem'},
                                        onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                        onKeyDown: (e) => {
                                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                e.preventDefault();
                                            }
                                        }
                                    }}
                                    onChange={(e) => {
                                        const inputValue = e.target.value;
                                        // Allow empty value
                                        if (inputValue === '') {
                                            field.onChange('');
                                            return;
                                        }

                                        let value = formatValue(e.target.value);
                                        if (value < 0 || isNaN(value)) {
                                            value = 0;
                                        }
                                        field.onChange(value);
                                        }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={1} sx={{display:{xs:'none',md:'block'}}}/>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>
                            Slider  Banner Position 
                            {/* <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box> */}
                        </Typography>
                        <Controller
                            control={control}
                            name="position"
                            rules={{
                                validate: value => {
                                    // Allow empty value
                                    if (value === '' || value === null || value === undefined) {
                                        return true;
                                    }
                                    // If there is a value, ensure it's a positive integer
                                    if (!Number.isInteger(Number(value)) || Number(value) <= 0) {
                                        return 'Please enter a positive integer';
                                    }
                                    return true;
                                }
                            }}
                            render={({field,fieldState:{error}})=>(
                                <TextField
                                    {...field}
                                    fullWidth
                                    type='number'
                                    size='small'
                                    error={!!error}
                                    InputProps={{
                                        style: {fontSize:'0.75rem'},
                                        onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                        onKeyDown: (e) => {
                                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                e.preventDefault();
                                            }
                                        }
                                    }}
                                    onChange={(e) => {
                                        const inputValue = e.target.value;
                                        
                                        // Allow empty value
                                        if (inputValue === '') {
                                            field.onChange('');
                                            return;
                                        }
                        
                                        // Convert to number and validate
                                        const numValue = parseInt(inputValue);
                                        if (numValue > 0) {
                                            field.onChange(numValue);
                                        } else if (numValue <= 0) {
                                            field.onChange('');
                                        } else {
                                            field.onChange('');
                                        }
                                    }}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            </Card>
        </Grid>
        {/* ================ Add Banner Category Modal =============== */}
        <Modal
            open={openBannerSectionDialog}
            // onClose={handleClose}
            disableEnforceFocus
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ 
                overflow: "scroll",
                '& .MuiBackdrop-root': {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                },
                '& .MuiBox-root': {
                    outline: 'none'  // Remove the focus outline
                }
                
            }}
        >
            <Box 
                sx={{
                    position: 'absolute',
                    top: (isMobile) ? '80%' : '50%',
                    left: '50%',
                    borderRadius:'1rem',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    // border: '2px solid #ddd',
                    // boxShadow: 24,
                    // p: 2,
                }}
                width={(isMobile) ? "95%" : "50%"}
            >
                <Card>
                    <AddEditCategory onClose={onCloseDialog}/>
                </Card>
            </Box>
        </Modal>

        {/* ================ Generate App Url Modal =============== */}
        <Modal
            open = {openGenerateAppUrl}
            disableEnforceFocus
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ 
                overflow: "scroll",
                '& .MuiBackdrop-root': {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                },
                '& .MuiBox-root': {
                    outline: 'none'  // Remove the focus outline
                }
                
            }}
        >
            <Box 
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    height:isSm? '100vh':'auto',
                    borderRadius:'1rem',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    // border: '2px solid #ddd',
                    // boxShadow: 24,
                    // p: 2,
                }}
                width={(isSm) ? "95%" : "50%"}
            >
                <Card>
                    <GenerateAppUrl 
                        onClose={()=>{
                            setOpenGenerateAppUrl(false);
                        }}
                    />
                </Card>
            </Box>
        </Modal>
    </>
  );
}

export default BannerForm;
const formatValue = (value) => {
    if (typeof value !== 'string') {
      return value === 0 ? '0' : value?.toString() || '';
    }
    const formatted = value.replace(/^0+(?=\d)/, '').replace(/^\./, '0.');
    return formatted === '' ? '' : formatted;
};